import { render, staticRenderFns } from "./video-area.vue?vue&type=template&id=25d0764c&scoped=true&"
import script from "./video-area.vue?vue&type=script&lang=ts&"
export * from "./video-area.vue?vue&type=script&lang=ts&"
import style0 from "./video-area.vue?vue&type=style&index=0&id=25d0764c&scoped=true&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d0764c",
  null
  
)

export default component.exports